import React from 'react';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import Debounce from 'react-debounce-component';
import ClearIcon from '@material-ui/icons/Clear';
import { ReactComponent as UpsellIcon } from 'assets/svg/upsell-icon.svg?react';
import classes from './upsell-widget.scss';
import appearAnimClasses from './appear.anim.scss';
import { TEXT_BOLD_CLASSES } from './get-upsell-classes';
const debounceTimeout = 1500;
const animationTimeout = 200;
export const UpsellWidgetComponent = ({
  onUpsellDismiss,
  className = '',
  proposedQuantity,
  fromPricePerItem,
  toPricePerItem,
  withCloseButton = true,
  isShown
}) => {
  const [isManuallyClosed, changeManuallyClosedState] = React.useState(false);
  function onClose() {
    changeManuallyClosedState(true);
    setTimeout(() => {
      changeManuallyClosedState(false);
    }, debounceTimeout);
    onUpsellDismiss();
  }
  return /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: appearAnimClasses,
    in: !isManuallyClosed,
    unmountOnExit: true,
    timeout: animationTimeout
  }, /*#__PURE__*/React.createElement(Debounce, {
    ms: debounceTimeout
  }, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: appearAnimClasses,
    in: isShown,
    unmountOnExit: true,
    timeout: animationTimeout
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.wrapper, className)
  }, /*#__PURE__*/React.createElement(UpsellIcon, {
    className: classes.icon
  }), /*#__PURE__*/React.createElement(Debounce, {
    ms: animationTimeout
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.text
  }, "Increase to ", /*#__PURE__*/React.createElement("span", {
    className: classes.bold
  }, proposedQuantity), " for a bigger quantity break discount (go\xA0from", ' ', /*#__PURE__*/React.createElement("span", {
    className: TEXT_BOLD_CLASSES
  }, fromPricePerItem), " to", ' ', /*#__PURE__*/React.createElement("span", {
    className: TEXT_BOLD_CLASSES
  }, toPricePerItem), " per item)")), withCloseButton && /*#__PURE__*/React.createElement(ClearIcon, {
    onClick: onClose,
    className: classes.clearIcon
  })))));
};